/** Code passed to WebSocket.close when disconnecting deliberately (keep in sync with close handlers). */

export const WS_CLOSE_INTENTIONAL = 3001;

/** Wall-clock window after first drop from last stable session: aggressive reconnect behaviour. */

export const WS_RAPID_RECONNECT_WINDOW_MS = 5 * 60 * 1000;

/** Max delay for one spaced retry in the rapid (exponential) phase. */

export const WS_MAX_RECONNECT_DELAY_MS = 5 * 60 * 1000;

/** Multiplier for rapid-phase delay between scheduled reconnect attempts. */

export const WS_RECONNECT_BACKOFF_MULTIPLIER = 2;

/**

 * Default base delay (ms) for rapid-phase spacing; each close may also trigger an immediate retry

 * while reconnectCount is 0. Grows by WS_RECONNECT_BACKOFF_MULTIPLIER up to WS_MAX_RECONNECT_DELAY_MS.

 */

export const WS_RECONNECT_RAPID_BASE_MS_DEFAULT = 5000;

/** Default long-phase step: after the rapid window, waits 1×, 2×, 3× … (default 5 minutes). */

export const WS_RECONNECT_LINEAR_STEP_MS_DEFAULT = 5 * 60 * 1000;

/**
 * Default cap on retry() invocations per outage before giving up.
 * 500 suits very long outages with linear spacing (override via BSDeliveryWsOptions.maxReconnectCount).
 */
export const WS_DEFAULT_MAX_RECONNECT_COUNT = 500;
